module.exports = __webpack_public_path__ + "img/13_maska_kniga.957f817.svg";